import { isPilot, isProd } from "../constants";

const customChickFilAPlanId = 95648;
const customPilotPlanId = 10000;

export function isChickFilA(planId: number) {
  if (isProd) {
    return planId === customChickFilAPlanId;
  } else {
    return planId === customPilotPlanId;
  }
}

function determineSecure05Host() {
  if (isPilot) {
    return "https://secure05.pilot.";
  }
  return "https://secure05.";
}

export const secure05Host = determineSecure05Host();
